if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
    }

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    bindEvents() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          
        });
      });

      

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      let main_product = document.querySelector(".cc-main-product");
      let product_info = main_product.querySelector('.product-info')
      let product_form = main_product.querySelector('product-form')
      let product_info_visible = elementIsVisibleInViewport(product_info);
      let product_form_visible = elementIsVisibleInViewport(product_form);
      let stickyATC = document.querySelector('sticky-atc-panel');
      if(product_info_visible || product_form_visible){
        if(!stickyATC.classList.contains('sticky-atc-panel--out')){
          stickyATC.classList.add('sticky-atc-panel--out');
        }
      }else{
        if(stickyATC.classList.contains('sticky-atc-panel--out')){
          stickyATC.classList.remove('sticky-atc-panel--out');
        }
      }
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}


const elementIsVisibleInViewport = (el, partiallyVisible = true) => {
  const { top, left, bottom, right } = el.getBoundingClientRect();
  const { innerHeight, innerWidth } = window;
  return partiallyVisible
    ? ((top > 0 && top < innerHeight) ||
        (bottom > 0 && bottom < innerHeight)) &&
        ((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
    : top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
};